import React from 'react';

// project-imports
import StencilBox from '../stencils/StencilBox';

function ContactUsFormStencil({ formStyle }) {

    return (
        // Adding disabled property in input box and button start here
        <form className={`${formStyle}`} action="" >
            <div className="col-lg-12">
                <div className="form-group">
                    <StencilBox
                        width="100%"
                        height="60px"
                        backgroundColor="#EEF1F6"
                    />
                </div>
            </div>

            <div className="col-lg-12">
                <div className="form-group">
                    <StencilBox
                        width="100%"
                        height="60px"
                        backgroundColor="#EEF1F6"
                    />
                </div>
            </div>

            <div className="col-lg-12">
                <div className="form-group">
                    <StencilBox
                        width="100%"
                        height="60px"
                        backgroundColor="#EEF1F6"
                    />

                    {/* Added pattern and autofocus required title in above line by Longswitch Team on 07/03/24 */}
                </div>
            </div>

            <div className="col-lg-12">
                <div className="form-group">
                    <StencilBox
                        width="100%"
                        height="60px"
                        backgroundColor="#EEF1F6"
                    />
                </div>
            </div>
            <div className="col-lg-12">
                <div className="form-group">
                    <StencilBox
                        width="100%"
                        height="180px"
                        backgroundColor="#EEF1F6"
                    />
                </div>
            </div>
            <div className="col-lg-12">

                {/* Adding Spinner icon Start Here */}
                <StencilBox
                    width="100%"
                    height="60px"
                    backgroundColor="#EEF1F6"
                />
                {/* Adding Spinner icon Start Here */}

            </div>
        </form>
        // Adding disabled property in input box and button End here
    )
}
export default ContactUsFormStencil;
